import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPaymentReceipt } from "../paymentreceiptModel";

export const getAllPaymentReceipt = createAsyncThunk(
  "PaymentReceipt/FindAllPaymentReceipt",
  async (skip: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PaymentReceipt/FindAllPaymentReceipt`,
        {
          skip: skip,
          limit: 1000,
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPaymentReceipt = createAsyncThunk(
  "PaymentReceipt/InsertPaymentReceipt",
  async (paymentreceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PaymentReceipt/InsertPaymentReceipt`,
        paymentreceipt
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePaymentReceipt = createAsyncThunk(
  "PaymentReceipt/UpdatePaymentReceipt",
  async (paymentreceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PaymentReceipt/UpdatePaymentReceipt`,
        paymentreceipt
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPaymentReceiptById = createAsyncThunk(
  "PaymentReceipt/FindByIDPaymentReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PaymentReceipt/FindByIDPaymentReceipt`,
        {
          payment_guid: ID,
        }
      );
      // SuccessToast(response.data?.Details || "Success")
      const result = response.data?.Data as any;
      return {
        receipt_date: result?.receipt_date
          ? new Date(result?.receipt_date)
          : "",
        karigar_id: result?.karigar_id,
        amount: result?.amount,
        remarks: result?.remarks,
      } as IPaymentReceipt;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePaymentReceipt = createAsyncThunk(
  "PaymentReceipt/DeletePaymentReceipt",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PaymentReceipt/DeletePaymentReceipt`,
        {
          payment_guid: ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllActivePaymentReceipt = createAsyncThunk(
  "PaymentReceipt/FindAllActivePaymentReceipt",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PaymentReceipt/FindAllActivePaymentReceipt`
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting PaymentReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// export const PaymentReceiptActiveInactive = createAsyncThunk(
//   "PaymentReceipt/ActiveInActivePaymentReceipt",
//   async (formData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/PaymentReceipt/ActiveInActivePaymentReceipt`,
//         formData
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error active-inactive PaymentReceipt:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );
